import React from 'react'
import { Document, Page, StyleSheet, View, Text, Image } from "@react-pdf/renderer";
import getLogo from './getLogo'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    fontSize: '10pt',
    padding: '2cm',
    textAlign: 'justify'
  },
  logo: {
    width: 50,
    height: 50,
  },
  title:{
    fontSize: '14pt',
  },
  main:{
    border: '1px solid black',
    borderRadius: 8,
    backgroundColor: '#eeeeee',
    padding: 12,
  },
  obs: {
    color: 'gray',
    fontSize: '9pt',
    lineHeight: '1.5pt',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    maxWidth: '100%',
    marginBottom: 4,
  },
  content:{
    lineHeight: '2pt',
  },
  field: {
    fontSize: '11pt',
    color: 'darkblue',
  },
  center:{
    textAlign: 'center',
  }
});

const apfelPdf = ({ nome, cpf, procedimentos, cidade, estado, data,
                   nomeExibicao, crm, risk, logoName}) => (

<Document title="APA" author={nome} creator="www.avaliacaopreanestesica.com">
  <Page style={styles.page} wrap={false}>
    <View style={styles.row}>
        <View><Image style={styles.logo} src={getLogo(logoName)}/></View>
        <View style={styles.center}>
          <Text style={styles.title}>Escore de APFEL para Risco de Náusea</Text>
          <Text style={styles.title}>e Vômito Pós-Operatório (NVPO)</Text>
    </View>
    </View>
    <View>
      <Text style={styles.content}> NOME: <Text style={styles.field}> {nome} </Text></Text>
      <Text style={styles.content}>PROCEDIMENTO(S): {"\n"}<Text style={styles.field}> {procedimentos} </Text></Text>
    </View>
    <View>
        {risk === 0 &&
          <Text style={styles.main}>
            <Text style={styles.content}>Não foi identificado nenhum fator de risco de Apfel{"\n"}</Text>
            <Text style={styles.content}>Sem profilaxia, a incidência de náuseas / vômitos no pós-operatório é de aproximadamente <Text style={styles.field}> 10</Text>%{"\n"}</Text>
          </Text>
        }
        {risk === 1 &&
          <Text style={styles.main}>
            <Text style={styles.content}>Foi identificado <Text style={styles.field}> 1 </Text> fator de risco de Apfel{"\n"}</Text>
            <Text style={styles.content}>Sem profilaxia, a incidência de náuseas / vômitos no pós-operatório é de aproximadamente <Text style={styles.field}> 20</Text>%{"\n"}</Text>
            <Text style={styles.content}>Está indicado o uso de <Text style={styles.field}> 2 </Text>agentes anti-eméticos{"\n"}</Text>
          </Text>
        }
        {risk === 2 &&
          <Text style={styles.main}>
            <Text style={styles.content}>Foram identificados <Text style={styles.field}> 2 </Text> fatores de risco de Apfel{"\n"}</Text>
            <Text style={styles.content}>Sem profilaxia, a incidência de náuseas / vômitos no pós-operatório é de aproximadamente <Text style={styles.field}> 40</Text>%{"\n"}</Text>
            <Text style={styles.content}>Está indicado o uso de <Text style={styles.field}> 2 </Text>agentes anti-eméticos{"\n"}</Text>
          </Text>
        }
        {risk === 3 &&
          <Text style={styles.main}>
            <Text style={styles.content}>Foram identificados <Text style={styles.field}> 3 </Text> fatores de risco de Apfel{"\n"}</Text>
            <Text style={styles.content}>Sem profilaxia, a incidência de náuseas / vômitos no pós-operatório é de aproximadamente <Text style={styles.field}> 60</Text>%{"\n"}</Text>
            <Text style={styles.content}>Está indicado o uso de <Text style={styles.field}> 3 ou 4 </Text>agentes anti-eméticos{"\n"}</Text>
          </Text>
        }
        {risk === 4 &&
          <Text style={styles.main}>
            <Text style={styles.content}>Foram identificados <Text style={styles.field}> 4 </Text> fatores de risco de Apfel{"\n"}</Text>
            <Text style={styles.content}>Sem profilaxia, a incidência de náuseas / vômitos no pós-operatório é de aproximadamente <Text style={styles.field}> 80</Text>%{"\n"}</Text>
            <Text style={styles.content}>Está indicado o uso de <Text style={styles.field}> 3 ou 4 </Text>agentes anti-eméticos{"\n"}</Text>
          </Text>
        }

    </View>
    <View>
      <Text style={styles.content}>
      RECOMENDAÇÕES GERAIS PARA REDUZIR RISCO DE NVPO:{"\n"}
      - Evitar anestesia geral, quando possível preferir anestesia regional. (A1){"\n"}
      - Usar propofol para indução e manutenção anestésica. (A1){"\n"}
      - Evitar óxido nitroso em cirurgias com duração maior que 1 hora (A1){"\n"}
      - Evitar anestésicos inalatórios (A2){"\n"}
      - Minimizar uso de opióides (A1){"\n"}
      - Hidratar adequadamente (A1){"\n"}
      - Usar sugammadex em vez de neostigmina na reversão do BNM (A1){"\n"}
      </Text>
    </View>
    <View>
      <Text style={styles.obs}>
      Todas as informações aqui contidas têm caráter apenas informativo.{"\n"}
      Quaisquer condutas médicas devem ser decididas pelo médico assistente
      juntamente com o paciente, respeitando os quatro princípios bioéticos
      fundamentais, quais sejam: autonomia, beneficência, não-maleficência e justiça.
      </Text>
      <Text style={styles.obs}>
      {"\n"}Fontes:{"\n"}
      - Apfel, Evidence-based analysis of risk factors for postoperative nausea and vomiting. Br J Anaesth. 2012.{"\n"}
      - Gan, Fourth Consensus Guidelines for the Management of Postoperative Nausea and Vomiting, Anesthesia & Analgesia, 2020
      </Text>
    </View>
    <View style={styles.center}>
      <Text>
        ______________________________________________________________
      </Text>
      <Text>
        ASSINATURA DO MÉDICO ANESTESIOLOGISTA
      </Text>
      <Text>
        {nomeExibicao}{crm && `, CRM: ${crm}`}
      </Text>
    </View>
    <View style={styles.center}>
      <Text style={styles.data}>
        {cidade && `${cidade}/${estado},`} {data.toLocaleDateString()}
      </Text>
    </View>
  </Page>
</Document>
);

export default apfelPdf
